function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".gauge_svg__cls-1{fill:none;stroke-linecap:round;stroke-linejoin:round;stroke:#63c;stroke-width:4px}"));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "gauge_svg__Layer_1-2"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 48,
  cy: 48.01,
  r: 25,
  stroke: "#ccc0fd",
  strokeWidth: 2,
  strokeLinejoin: "round",
  fill: "none",
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 48,
  cy: 48.01,
  r: 7.5,
  fill: "#00ffcb",
  stroke: "#63c",
  strokeWidth: 4,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  className: "gauge_svg__cls-1",
  d: "M55.5 47.87l2.86-28.03-16.02 23.24M87.84 71l-6.92-3.99M8.16 71l6.92-3.99M18.43 12.76l5.15 6.13M77.57 12.76l-5.15 6.13M93.3 40.02l-7.88 1.39M2.7 40.02l7.88 1.39M48 10.01V2"
}), /*#__PURE__*/React.createElement("path", {
  className: "gauge_svg__cls-1",
  d: "M8.16 71A45.738 45.738 0 012 48C2 22.59 22.59 2 48 2s46 20.59 46 46c0 8.38-2.24 16.24-6.16 23"
}));

function SvgGauge(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "gauge_svg__Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 96 74.01"
  }, props), _ref, _ref2);
}

export default "data:image/svg+xml;base64,PHN2ZyBpZD0iTGF5ZXJfMiIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB2aWV3Qm94PSIwIDAgOTYgNzQuMDEiPgogICAgPGRlZnM+CiAgICAgICAgPHN0eWxlPgogICAgICAgICAgICAuY2xzLTEsLmNscy0ye2ZpbGw6bm9uZTtzdHJva2UtbGluZWNhcDpyb3VuZDt9LmNscy0xLC5jbHMtMiwuY2xzLTN7c3Ryb2tlLWxpbmVqb2luOnJvdW5kO30uY2xzLTEsLmNscy0ze3N0cm9rZTojNjNjO3N0cm9rZS13aWR0aDo0cHg7fS5jbHMtMntzdHJva2U6I2NjYzBmZDtzdHJva2Utd2lkdGg6MnB4O30uY2xzLTN7ZmlsbDojMDBmZmNiO308L3N0eWxlPgogICAgPC9kZWZzPgogICAgPGcgaWQ9IkxheWVyXzEtMiI+CiAgICAgICAgPGc+CiAgICAgICAgICAgIDxjaXJjbGUgY2xhc3M9ImNscy0yIiBjeD0iNDgiIGN5PSI0OC4wMSIgcj0iMjUiIC8+CiAgICAgICAgICAgIDxnPgogICAgICAgICAgICAgICAgPGNpcmNsZSBjbGFzcz0iY2xzLTMiIGN4PSI0OCIgY3k9IjQ4LjAxIiByPSI3LjUiIC8+CiAgICAgICAgICAgICAgICA8cG9seWxpbmUgY2xhc3M9ImNscy0xIiBwb2ludHM9IjU1LjUgNDcuODcgNTguMzYgMTkuODQgNDIuMzQgNDMuMDgiIC8+CiAgICAgICAgICAgIDwvZz4KICAgICAgICAgICAgPGxpbmUgY2xhc3M9ImNscy0xIiB4MT0iODcuODQiIHkxPSI3MSIgeDI9IjgwLjkyIiB5Mj0iNjcuMDEiIC8+CiAgICAgICAgICAgIDxsaW5lIGNsYXNzPSJjbHMtMSIgeDE9IjguMTYiIHkxPSI3MSIgeDI9IjE1LjA4IiB5Mj0iNjcuMDEiIC8+CiAgICAgICAgICAgIDxsaW5lIGNsYXNzPSJjbHMtMSIgeDE9IjE4LjQzIiB5MT0iMTIuNzYiIHgyPSIyMy41OCIgeTI9IjE4Ljg5IiAvPgogICAgICAgICAgICA8bGluZSBjbGFzcz0iY2xzLTEiIHgxPSI3Ny41NyIgeTE9IjEyLjc2IiB4Mj0iNzIuNDIiIHkyPSIxOC44OSIgLz4KICAgICAgICAgICAgPGxpbmUgY2xhc3M9ImNscy0xIiB4MT0iOTMuMyIgeTE9IjQwLjAyIiB4Mj0iODUuNDIiIHkyPSI0MS40MSIgLz4KICAgICAgICAgICAgPGxpbmUgY2xhc3M9ImNscy0xIiB4MT0iMi43IiB5MT0iNDAuMDIiIHgyPSIxMC41OCIgeTI9IjQxLjQxIiAvPgogICAgICAgICAgICA8bGluZSBjbGFzcz0iY2xzLTEiIHgxPSI0OCIgeTE9IjEwLjAxIiB4Mj0iNDgiIHkyPSIyIiAvPgogICAgICAgICAgICA8cGF0aCBjbGFzcz0iY2xzLTEiCiAgICAgICAgICAgICAgICBkPSJNOC4xNiw3MWMtMy45Mi02Ljc3LTYuMTYtMTQuNjItNi4xNi0yM0MyLDIyLjU5LDIyLjU5LDIsNDgsMnM0NiwyMC41OSw0Niw0NmMwLDguMzgtMi4yNCwxNi4yNC02LjE2LDIzIiAvPgogICAgICAgIDwvZz4KICAgIDwvZz4KPC9zdmc+";
export { SvgGauge as ReactComponent };